import TranslatedText from '@sms/plasma-ui/lib/components/TranslatedText/TranslatedText';
import React, { FC } from 'react';

import { IMMStatistics, TSegStatistics } from '../../../../../store/api/segregation/types';

interface IProps {
  statistics: TSegStatistics;
  mmStatistics: IMMStatistics | null | undefined;
}

export const NormAreaRow: FC<IProps> = ({ statistics, mmStatistics }) => {
  return (
    <>
      {statistics && 'normArea' in statistics && (
        <li className="seg__statistics__item">
          <p>
            <TranslatedText textKey="side-menu.norm-area" /> [%]:
          </p>
          <p>{statistics.normArea + `${mmStatistics ? ` (${mmStatistics?.normArea})` : ''}`}</p>
        </li>
      )}
    </>
  );
};
